import { render, staticRenderFns } from "./ActivityTagIndex.vue?vue&type=template&id=a78052ba&scoped=true&"
import script from "./ActivityTagIndex.vue?vue&type=script&lang=js&"
export * from "./ActivityTagIndex.vue?vue&type=script&lang=js&"
import style0 from "./ActivityTagIndex.vue?vue&type=style&index=0&id=a78052ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a78052ba",
  null
  
)

export default component.exports